import { useTranslation } from '@cobliteam/i18n';
import type { Column, Table } from '@tanstack/react-table';
import type React from 'react';
import DataTableColumns from '../components/DataTableColumns';
import ExportComponent from '../components/Export';
import DataTableSearchInput from './DataTableSearchInput';

interface SearchAndToolsProps<TData> {
  globalFilter: string;
  onChangeSearch: (value: string) => void;
  table: Table<TData>;
  columns: Column<TData>[];
  visibleColumns: Column<TData>[];
  customToolbar: React.ReactNode;
  exportDef: any;
  Export: any;
  data: TData[];
  placeholder?: string;
  search?: string | false;
  showColumnFilter?: boolean;
  showSearch?: boolean;
}

const DataTableSearchAndTools = <TData,>({
  data,
  onChangeSearch,
  table,
  columns,
  visibleColumns,
  customToolbar,
  exportDef,
  Export,
  placeholder,
  showSearch = false,
  search,
  showColumnFilter = true,
}: SearchAndToolsProps<TData>) => {
  const { t } = useTranslation('ui-business');
  const defaultPlaceholder = placeholder || t('data_table.search_placeholder');

  const shouldRenderToolbar = showSearch || customToolbar || showColumnFilter || (Export && data) || (exportDef && data);

  if (!shouldRenderToolbar) return null;

  return (
    <div className='grid grid-cols-12 items-center gap-2'>
      <div className='col-span-12 laptop:col-span-8 tablet:col-span-12 flex flex-wrap items-center gap-2'>
        {showSearch && <DataTableSearchInput value={search || ''} placeholder={defaultPlaceholder} onChange={onChangeSearch} />}
        {customToolbar}
      </div>
      <div className='col-span-12 laptop:col-span-4 tablet:col-span-12 flex justify-start laptop:justify-end gap-2'>
        {showColumnFilter && <DataTableColumns columns={columns} visibleColumns={visibleColumns} />}
        <div>
          {exportDef && Export && data ? Export(table, data, exportDef) : null}
          {!exportDef && Export && data ? Export(table, data, exportDef) : null}
          {exportDef && !Export && data ? <ExportComponent data={data} table={table} exportDef={exportDef} /> : null}
        </div>
      </div>
    </div>
  );
};

export default DataTableSearchAndTools;
